import React from 'react';
import {
  Dialog,
  Box,
  Typography,
  Button,
  IconButton,
  useTheme,
} from '@mui/material';
import MacbookFrame from './MacbookFrame';
import Logo from '../assets/images/onlylogo_kali.svg';
import LogoWhite from '../assets/images/only_logo_white.svg';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FREE_QUESTION, questionTemplates } from '../const';

const WelcomeAstrologyDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0,0,0,0.2)',
          },
        },
        paper: {
          sx: {
            borderRadius: '16px',
            padding: 2,
            textAlign: 'center',
            backgroundImage: 'none',
            backgroundColor: theme.palette.background.default,
          },
        },
      }}
    >
      {/* Video Placeholder */}
      <MacbookFrame />

      {/* Divider with Icon */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          mt: 4.5,
        }}
      >
        <Box
          sx={{
            height: '1px',
            backgroundColor: '#e0e0e0',
            flex: 1,
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            width: 60,
            height: 60,
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.background.default,
            mx: 2,
            p: 1,
          }}
        >
          {theme.palette.mode === 'dark' ? (
            <Box
              component="img"
              src={LogoWhite}
              sx={{ width: 59, height: 59 }}
            />
          ) : (
            <Box component="img" src={Logo} sx={{ width: 59, height: 59 }} />
          )}
        </Box>

        <Box
          sx={{
            height: '1px',
            backgroundColor: '#e0e0e0',
            flex: 1,
          }}
        />
      </Box>

      {/* Title */}
      <Typography
        variant="h2"
        sx={{
          mt: 2,
          fontSize: 'clamp(22px, 3.2vw, 30px)',
        }}
      >
        Welcome to future of Astrology
      </Typography>

      {/* Description */}
      <Typography
        variant="h4"
        sx={{
          margin: '0 auto',
          mt: -2,
          mb: 3,
          mx: 4,
        }}
      >
        India’s first self-trained AI built on Vedic Principles and expert
        insights no generic answers, only truth.
      </Typography>

      <Button
        variant="contained"
        size="large"
        color="secondary"
        sx={{
          maxWidth: '300px',
          pl: 3,
          mx: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,

          '& .arrow': {
            opacity: 0,
            transform: 'translateX(-6px)',
            transition: 'all 0.25s ease',
          },

          '&:hover .arrow': {
            opacity: 1,
            transform: 'translateX(0)',
          },
        }}
        onClick={() => {
          navigate('/chat', { state: { prefill: FREE_QUESTION } });
          onClose();
        }}
      >
        <Box sx={{ width: 15 }} fontSize="small" />
        One Question is free
        <ArrowForwardIcon className="arrow" fontSize="small" />
      </Button>

      {/* Learn More */}
      <Typography
        sx={{
          mt: 2,
          fontSize: '14px',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/home/Home')}
      >
        Learn more
      </Typography>
    </Dialog>
  );
};

export default WelcomeAstrologyDialog;
